export default "__VITE_ASSET__DcQMbfS0__"